import { Component, OnInit, Input, EventEmitter, Output } from "@angular/core";

@Component({
  selector: "scaffold-dialog",
  templateUrl: "./scaffold-dialog.component.html",
  styleUrls: ["./scaffold-dialog.component.scss"],
})
export class ScaffoldDialogComponent implements OnInit {
  /**Title for Dialog*/
  @Input() title: string;
  /**Size of dialog 'wide' = 90vw, 'half' = 50vw*/
  @Input() size: string = "wide";
  /**Set overflow of content to hidden*/
  @Input() fit: boolean = false;
  /** fill the height of the window*/
  @Input() fullHeight: boolean;
  /** Whether it will have buttons layed out at the end of the modal or by default spread between evenly with the available space*/
  @Input() buttonsFlexEnd: boolean = false;
  /** Show a close button for the modal*/
  @Input() showCloseButton: boolean = false;
/** Show a collapse button for the modal*/
  @Input() showCollapseButton: boolean = false;
/** take true full view of the window*/
  @Input() fullView: boolean = false;

  @Output() close = new EventEmitter<any>();

  constructor() {}

  ngOnInit(): void {}

  handleClose() {
    this.close.emit();
  }
}
